<template>
  <authorization permissionKey="surgery_ward_intraoperative_queue" can="read">
    <attendances queueType="surgery_intraoperative" medicalRecordPath="cirurgia" />
  </authorization>
</template>

<script>
import attendances from "@/components/queues/attendances.vue";

  export default {
    name: "SurgicalWardIntraoperative",
    components: {
      attendances,
    },
  };
</script>

<style lang="scss" scoped></style>
